let routes = [
  {
    path: '/user-agreement',
    name: 'UserAgreeMent',
    component: () => import('@/views/system/pages/UserAgreeMent.vue'),
    meta: {
      title: '用户服务协议',
      keepAlive: false
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/system/pages/Privacy.vue'),
    meta: {
      title: '隐私政策',
      keepAlive: false
    }
  },
  {
    path: '/licence-list',
    name: 'LicenceList',
    component: () => import('@/views/system/pages/LicenceList.vue'),
    meta: {
      title: '我的证照',
      keepAlive: false
    }
  },
  {
    path: '/rich-text',
    name: 'RichText',
    component: () => import('@/views/system/pages/RichText.vue'),
    meta: {
      title: '应用简介',
      keepAlive: false
    }
  },
  {
    path: '/licence-add',
    name: 'LicenceAdd',
    component: () => import('@/views/system/pages/LicenceAdd.vue'),
    meta: {
      title: '添加证件',
      keepAlive: false
    }
  },
  {
    path: '/licence-detail',
    name: 'LicenceDetail',
    component: () => import('@/views/system/pages/LicenceDetail.vue'),
    meta: {
      title: '',
      keepAlive: false
    }
  },
  {
    path: '/licence-img',
    name: 'LicenceImg',
    component: () => import('@/views/system/pages/LicenceImg.vue'),
    meta: {
      title: '',
      keepAlive: false
    }
  },
  {
    path: '/download',
    name: 'RichText',
    component: () => import('@/views/system/pages/Download.vue'),
    meta: {
      title: '下载',
      keepAlive: false
    }
  },
  {
    path: '/my-points',
    name: 'MyPoints',
    component: () => import('@/views/system/pages/MyPoints.vue'),
    meta: {
      title: '我的积分',
      keepAlive: false
    }
  },
  {
    path: '/points-list',
    name: 'PointsList',
    component: () => import('@/views/system/pages/PointsList.vue'),
    meta: {
      title: '积分明细',
      keepAlive: false
    }
  },
  {
    path: '/zfq',
    name: 'zfq',
    component: () => import('@/views/system/pages/Zfq.vue'),
    meta: {
      title: '',
      keepAlive: false
    }
  }
]

routes = [...routes]

export default routes
